import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getLayout } from './layouts';

export const settings = {
  defaultMinTeases: 5,
  defaultMaxTeases: 9,
  liveBlogMinTeases: 2,
  liveBlogMaxTeases: 4,
};

// eslint-disable-next-line react/prefer-stateless-function
class TeaseLayout extends React.Component {
  static propTypes = {
    layoutType: PropTypes.string,
    totalTeases: PropTypes.number,
    columnType: PropTypes.string,
    render: PropTypes.func,
    isRailAdjacent: PropTypes.bool,
  };

  static defaultProps = {
    layoutType: 'default',
    totalTeases: 0,
    columnType: '',
    isRailAdjacent: false,
    render: () => null,
  };

  render() {
    const {
      totalTeases,
      layoutType: type,
      render,
      columnType,
      isRailAdjacent,
    } = this.props;
    const {
      defaultMinTeases,
      defaultMaxTeases,
      liveBlogMinTeases,
      liveBlogMaxTeases,
    } = settings;

    if (!totalTeases) return null;

    const layout = getLayout(type, isRailAdjacent, totalTeases);

    if (type === 'liveBlog') {
      // Check that number of variations is between min and max
      if (!(totalTeases >= liveBlogMinTeases && totalTeases <= liveBlogMaxTeases)) {
        return null;
      }
      return (
        <div
          className={classNames(
            `cs-liveblog-layout cs-liveblog-layout--${totalTeases}-teases`,
            { [`cs-${totalTeases}-rail${columnType}`]: isRailAdjacent },
          )}
          data-test="cs-liveblog-layout"
        >
          {render(layout)}
        </div>
      );
    }

    if (!(totalTeases >= defaultMinTeases && totalTeases <= defaultMaxTeases)) {
      return null;
    }

    return (
      <div
        className={classNames(
          `cs-layout cs-${totalTeases}-slot-layout${columnType}`,
          { [`cs-rail${columnType}`]: isRailAdjacent },
        )}
        data-test="cs-default-layout"
      >
        {render(layout)}
      </div>
    );
  }
}

export default TeaseLayout;
